
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.91 6.35H3.224a.225.225 0 00-.225.225v3.15h5.91V6.35zm.75-1.5h7.216c1.589 0 3.037.884 4.057 2.313 1.019 1.426 1.568 3.32 1.568 5.263v4.876a.75.75 0 01-.75.75h-1.318a2.701 2.701 0 01-5.165 0H8.732a2.701 2.701 0 01-5.165 0H2.249a.75.75 0 01-.75-.75V6.576A1.725 1.725 0 013.224 4.85H9.66zm.75 1.5v3.376h5.607l-.723-3.376H10.41zm5.929 4.876H2.999v5.326h.544a2.701 2.701 0 015.213 0h6.488a2.701 2.701 0 015.213 0h.544v-3.376h-3.638a.75.75 0 01-.733-.593l-.291-1.357zm4.63.45h-3L16.83 6.35h.047c.997 0 2.029.554 2.837 1.685.688.964 1.137 2.248 1.256 3.641zM4.95 17.26a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0zm12.902-1.2a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z"}})])
          )
        }
      }
    